import React from 'react';
import { ClienteConsolidado } from '../types';
import { calcularInsightsCarteira, type IdInsight } from '../lib/insightsCarteira';
import { Target, TrendingUp, Zap, AlertCircle, CheckCircle2 } from 'lucide-react';

interface Props {
  clientes: ClienteConsolidado[];
  totalAberto: number;
}

// O texto dos insights vive em lib/insightsCarteira.ts para a exportação em
// Excel escrever exatamente a mesma leitura da carteira. Aqui fica só o ícone.
const ICONES: Record<IdInsight, React.ReactNode> = {
  tendencia: <TrendingUp size={16} />,
  concentracao: <Target size={16} />,
  saldos: <Zap size={16} />,
  lote: <CheckCircle2 size={16} />,
};

const InsightsIA: React.FC<Props> = ({ clientes, totalAberto }) => {
  const insights = calcularInsightsCarteira(clientes, totalAberto);

  return (
    <div className="p-6 h-full flex flex-col overflow-y-auto">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold text-gray-800">Insights Automáticos por IA</h2>
          <p className="text-sm text-gray-500">Análise prescritiva do comportamento da carteira</p>
        </div>
        <AlertCircle className="text-[#5F6C37]" size={24} />
      </div>

      <div className="space-y-4">
        {insights.map((ins) => (
          <div key={ins.id} className="rounded-xl border overflow-hidden bg-white shadow-sm" style={{ borderColor: ins.cor + '40' }}>
            <div className="px-5 py-3 flex items-center justify-between" style={{ background: ins.cor + '12' }}>
              <div className="flex items-center gap-2" style={{ color: ins.cor }}>
                {ICONES[ins.id]}
                <span className="font-bold text-sm">{ins.titulo}</span>
              </div>
              <span className="text-[10px] font-black px-2 py-0.5 rounded-full text-white" style={{ background: ins.cor }}>{ins.nivel}</span>
            </div>
            <div className="px-5 py-4">
              <p className="text-sm text-gray-700 leading-relaxed mb-3">{ins.texto}</p>
              <div className="p-3 rounded-lg flex items-start gap-3" style={{ background: ins.cor + '08', borderLeft: `3px solid ${ins.cor}` }}>
                <div className="mt-0.5 text-xs font-bold text-gray-800 uppercase tracking-wide">Ação Sugerida:</div>
                <p className="text-xs font-semibold text-gray-700 flex-1">{ins.recomendacao}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsIA;
